import React, {useState, useEffect} from 'react';
import Email from "./Icons/Email";
import Logo from "./Icons/Logo";
import {scrollToElement, smoothNavigate} from "../helpers/Animation";

const NavigationBar = (props) => {
    const [emailActive, setEmailActive] = useState(false);

    useEffect(() => {
        if (!!emailActive) {
            emailOnClick();
        }
    }, [emailActive])

    const logoOnClick = (event) => {
        event.stopPropagation();
        event.preventDefault();

        scrollToElement('.nav-container', () => {});
    }

    const emailOnClick = () => {
        smoothNavigate(() => {
            setEmailActive(false)
        }, '#contact-section')
    }

    return (
        <div className={'navigation-bar'}>
            <div className="section-guttering-container">
                <div className="section-guttering-inner row m-0 p-0 d-flex justify-content-between">
                    <div className="col-6 m-0 p-0 nav-left-col d-flex justify-content-start align-items-center">
                        <Logo
                            type={"dark"}
                            onClick={(event) => logoOnClick(event)}
                        />
                    </div>
                    <div className="col-6 m-0 p-0 nav-right-col d-flex justify-content-end align-items-center">
                        <div className="d-flex justify-content-end align-items-center">
                            <Email
                                onClick={() => setEmailActive(true)}
                                active={emailActive}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default NavigationBar;
